namespace GeniuzPOS.Administration {
    export interface SysGroupForm {
        SysGroup: Serenity.StringEditor;
        SysGroupDesc: Serenity.StringEditor;
    }

    export class SysGroupForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.SysGroup';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SysGroupForm.init)  {
                SysGroupForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(SysGroupForm, [
                    'SysGroup', w0,
                    'SysGroupDesc', w0
                ]);
            }
        }
    }
}
